import { render, staticRenderFns } from "./TeacherGroupPage.vue?vue&type=template&id=283f665f&scoped=true&"
import script from "./TeacherGroupPage.vue?vue&type=script&lang=js&"
export * from "./TeacherGroupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f665f",
  null
  
)

export default component.exports